export const htmlContent = (value: string) => {
  if (value) return {__html: value};
  return {__html: ''};
};
